import { createSlice } from "@reduxjs/toolkit";

export const languageSlice = createSlice({
  name: "LanguageSlice",
  initialState: {
    language: window.localStorage.getItem("lang") || "fr", // "fr" for french
  },
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export const updateLanguage = (language) => (dispatch) => {
  dispatch(setLanguage(language));
};

export default languageSlice.reducer;
